import { IAuthState } from './features/auth/auth.reducer';
import { IEventCardState } from './features/event-card/state/event-card.reducer';
import { IEventListState } from './features/event-list/state/event-list.reducer';
import { IPublicState } from './features/public/public.reducer';
import { IPvsTaskState } from './features/pvs-task/state/pvs-task.reducer';

export enum EStateStatus {
  PENDING = 'PENDING',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface IAppState {
  auth: IAuthState;
  public: IPublicState;
  pvsTask: IPvsTaskState;
  eventList: IEventListState;
  eventCard: IEventCardState;
}
